import { render } from "./BatchStatusDropdownFilterContainer.vue?vue&type=template&id=013d1d84"
import script from "./BatchStatusDropdownFilterContainer.vue?vue&type=script&lang=js"
export * from "./BatchStatusDropdownFilterContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__